import { CloseDeliveries, ApiWeeklySchedule, OpeningHoursType } from 'apis/merchant-onboarding-service/types';
import { WeeklyScheduleInputEntry } from 'common/components/weekly-schedules';
import { TimePair } from 'common/components/weekly-schedules/WeeklyScheduleInput/types';

import { NormalOpeningHoursEntries } from './OpeningHoursTab/types';

export const DEFAULT_TIME_PAIR: TimePair = {
  endMinutes: 24 * 60,
  startMinutes: 0,
};

export const DEFAULT_COMPLICATED_OPENING_HOURS: WeeklyScheduleInputEntry[] = [
  {
    daysOfWeek: [],
    timePairs: [DEFAULT_TIME_PAIR],
    open24Hours: false,
  },
];

export const DEFAULT_NORMAL_OPENING_HOURS: NormalOpeningHoursEntries = {
  monday: { isOpen: true, from: 9 * 60, to: 18 * 60 },
  tuesday: { isOpen: true, from: 9 * 60, to: 18 * 60 },
  wednesday: { isOpen: true, from: 9 * 60, to: 18 * 60 },
  thursday: { isOpen: true, from: 9 * 60, to: 18 * 60 },
  friday: { isOpen: true, from: 9 * 60, to: 18 * 60 },
  saturday: { isOpen: true, from: 9 * 60, to: 18 * 60 },
  sunday: { isOpen: true, from: 9 * 60, to: 18 * 60 },
};

export const DEFAULT_OPENING_HOURS_TYPE: OpeningHoursType = 'normal';

export const DEFAULT_CLOSE_DELIVERIES: CloseDeliveries = 'at-closing';

export const TWENTY_FOUR_SEVEN_WEEKLY_SCHEDULE: ApiWeeklySchedule = {
  monday: [{ type: 'open', value: 0 }],
  tuesday: [],
  wednesday: [],
  thursday: [],
  friday: [],
  saturday: [],
  sunday: [{ type: 'close', value: 24 * 3600 * 1000 }],
};

export const DEFAULT_WEEKLY_SCHEDULE: ApiWeeklySchedule = {
  monday: [],
  tuesday: [],
  wednesday: [],
  thursday: [],
  friday: [],
  saturday: [],
  sunday: [],
};
